exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".rga-tab .rga-analysis-tabs{font-size:15px;margin-top:7px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/rga/recalled-part-analysis/components/advance-returned-part-information/rga-tab.scss
// module id = 5213
// module chunks = 0